import { FC, PropsWithChildren } from 'react';
import { cx } from '@emotion/css';

import { containerQueries } from '@phoenix/design-system/frontend/ui/breakpoints/breakpoints';
import { PhoenixImage } from '@phoenix/core/frontend/shared/ui/assets/phoenix-image';

interface PromotionalHeaderProps extends PropsWithChildren {
  headline?: string;
  description: string;
  className?: string;
  imageSrc?: string;
}

export const PromotionalHeader: FC<PromotionalHeaderProps> = ({ headline, description, className, imageSrc, children }) => {
  const imageProps = imageSrc && {
    src: imageSrc,
    sizes: `(max-width: ${containerQueries.tablet}) 100vw, (max-width: ${containerQueries.desktop}) 50vw, 30vw`,
    staticTags: ['imagesDashboard'],
  };

  return (
    <div className={cx('flex flex-col justify-center rounded-lg border border-secondary-mid bg-primary-white p-6', className)}>
      <div className="flex items-center">
        {imageProps && (
          <div className="relative hidden aspect-[16/9] h-fit w-full tablet:block">
            <PhoenixImage layout="fill" objectFit="contain" {...imageProps} />
          </div>
        )}
        <div className={cx('flex flex-col', imageSrc && 'tablet:max-w-sm')}>
          {headline && <h4 className="stihl-text-highlight-flag">{headline}</h4>}
          {imageProps && (
            <div className="relative aspect-[16/9] h-fit w-full tablet:hidden">
              <PhoenixImage layout="fill" objectFit="contain" {...imageProps} />
            </div>
          )}
          <div>
            <p className={cx('stihl-text-body-default-reg', { 'mt-4': !!(headline || imageProps) })}>{description}</p>
          </div>
        </div>
      </div>
      {children}
    </div>
  );
};
